<template>
  <div>
    <issue-order ref="order" :type="type" @clearDetails="clearDetails" @issue="issue" @restore="restore" @showDetails="showDetails"/>
    <issue-detail ref="details" :type="type"/>
  </div>
</template>

<script>
import IssueOrder from '@/views/outbound/issue/IssueOrder.vue'
import IssueDetail from '@/views/outbound/issue/IssueDetail.vue'

export default {
  name: 'IssueTemplate',
  components: { IssueOrder, IssueDetail },
  data() {
    return {}
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    refresh() {
      this.$refs.order.refresh()
    },
    issue(row) {
      this.$emit('issue', row.order.id)
    },
    restore(row) {
      this.$emit('restore', row.order.id)
    },
    showDetails(row) {
      this.$refs.details.refresh(row.order.id)
    },
    clearDetails() {
      this.$refs.details.clear()
    }
  }
}
</script>